// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCwNt7OZZTEpvFmJmZFe_uc9flMGlYe5mA",
  authDomain: "laraveltesting-128e2.firebaseapp.com",
  projectId: "laraveltesting-128e2",
  storageBucket: "laraveltesting-128e2.appspot.com",
  messagingSenderId: "349438500421",
  appId: "1:349438500421:web:6a84c082e140d3b8304d2c",
  measurementId: "G-JN4B0DY3E0",
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

// 🔹 Request Notification Permission & Get Token
export const requestForToken = async () => {
  try {
    const token = await getToken(messaging, {
      vapidKey:
        "BH1yuZrRqHls3JNr2VR4O9s7NkS-5cLT_-30z6sHkS4yFYB8z2kBtQsbJlotv-ivtVigeIOINY4nxugv7OQoi_o",
    });
    if (token) {
      localStorage.setItem("fcToken", token);
      // console.log("✅ FCM Token:", token);
    };
    
  } catch (err) {
    console.error("⚠️ Error getting token:", err);
  }
};

// 🔹 Listen for foreground messages (returns unsubscribe function)
export const listenForMessages = (callback) => {
  return onMessage(messaging, callback); 
};

export default app;
